module.exports = __webpack_public_path__ + "img/calendar-11_fill.e99470dc.svg";